import { cn } from "@/lib/cn";

/**
 * The Character Studio mark, inline rather than an `<img>`.
 *
 * Inline means it inherits `currentColor` and needs no second network request
 * at first paint. The raster copies under `public/icons/` exist only for the
 * web manifest and the favicon, which cannot take SVG everywhere.
 */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 64 64"
      role="img"
      aria-label="Character Studio"
      className={cn("size-6", className)}
    >
      <rect width="64" height="64" rx="16" className="fill-accent" />
      <path
        d="M41.5 23.2a12.6 12.6 0 1 0 0 17.6"
        fill="none"
        className="stroke-bg"
        strokeWidth="6.5"
        strokeLinecap="round"
      />
      <circle cx="45" cy="45" r="4.2" className="fill-bg" />
    </svg>
  );
}
